// Display helpers (parity with Fmt in Models.swift).

export function parseDate(s: string | null | undefined): number | null {
  if (!s) return null;
  const t = Date.parse(s);
  return Number.isNaN(t) ? null : t;
}

/** "3 h", "2 d", "just now" — relative age for list rows. */
export function ageLabel(s: string | null | undefined, now: number = Date.now()): string {
  const t = parseDate(s);
  if (t == null) return '';
  const secs = (now - t) / 1000;
  if (secs < 90) return 'just now';
  if (secs < 3600) return `${Math.floor(secs / 60)} min`;
  if (secs < 86400) return `${Math.floor(secs / 3600)} h`;
  return `${Math.floor(secs / 86400)} d`;
}

/** Hours (from the server's ageHours) -> "40 min", "5 h", "3 d". */
export function hoursLabel(h: number | null | undefined): string {
  if (h == null) return '';
  if (h < 1) return `${Math.floor(h * 60)} min`;
  if (h < 48) return `${Math.floor(h)} h`;
  return `${Math.floor(h / 24)} d`;
}

export function titleCase(s: string | null | undefined): string {
  if (!s) return '';
  return s.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}
